import { useEffect, useState } from 'react';

import { Box, useBreakpoint } from '@bcp-nextgen-dx-component-factory/design-system';
import { useCookiesConsent, useDrawer, useModal } from '@hooks';

import { AppDrawer } from '../base';
import { DrawerContent, DrawerFooter, DrawerHeader } from './components';

export const CookiesPreferencesDrawer = () => {
	const drawer = useDrawer('cookiesPreferences');
	const modal = useModal('cookiesConsent');
	const isDesktop = useBreakpoint() === 'desktop';

	const {
		remarketingAccepted: remarketingAcceptedStore,
		privacyPreferences: privacyPreferencesStore,
		handleAcceptAllCookies: acceptAllCookies,
		handleSavePreferences: savePreferences,
	} = useCookiesConsent();

	const [remarketingAccepted, setRemarketingAccepted] = useState(!!remarketingAcceptedStore);
	const [privacyPreferences, setPrivacyPreferences] = useState(privacyPreferencesStore || []);

	useEffect(() => {
		if (privacyPreferencesStore) {
			setPrivacyPreferences(privacyPreferencesStore);
		}
	}, [privacyPreferencesStore]);

	useEffect(() => {
		if (typeof remarketingAcceptedStore === 'boolean') {
			setRemarketingAccepted(remarketingAcceptedStore);
		}
	}, [remarketingAcceptedStore]);

	const handleDrawerDismiss = () => {
		resetState();

		drawer.hide();
		modal.show();
	};

	const handlePrivacyPreferenceToggle = (idFamily?: string) => {
		setPrivacyPreferences((currentPreferences) => {
			return currentPreferences?.map((pref) => ({
				...pref,
				accepted: pref.idFamily === idFamily ? !pref.accepted : pref.accepted,
			}));
		});
	};

	const handleSavePreferences = () => {
		savePreferences(privacyPreferences, remarketingAccepted);
	};

	const resetState = () => {
		setRemarketingAccepted(!!remarketingAcceptedStore);
		setPrivacyPreferences(privacyPreferencesStore || []);
	};

	return (
		<AppDrawer
			visible={drawer.isVisible}
			position={isDesktop ? 'right' : 'bottom'}
			overlay={{ onClick: handleDrawerDismiss }}
		>
			<Box
				styles={{
					flexDirection: 'column',
					height: '100%',
					maxHeight: isDesktop ? '100vh' : '87vh',
					overflow: 'hidden',
				}}
			>
				<DrawerHeader onCloseClick={handleDrawerDismiss} />

				<DrawerContent
					privacyPreferences={privacyPreferences}
					remarketingAccepted={remarketingAccepted}
					onPrivacyPreferenceToggle={handlePrivacyPreferenceToggle}
					onRemarketingChipClick={setRemarketingAccepted}
				/>

				<DrawerFooter onAcceptAllCookies={acceptAllCookies} onSavePreferences={handleSavePreferences} />
			</Box>
		</AppDrawer>
	);
};
